import { Pipe, PipeTransform } from '@angular/core';
import { NO_VALUE } from '@pipes';

@Pipe({
  name: 'toInteger',
  standalone: true,
})
export class ToIntegerPipe implements PipeTransform {
  transform(value: number | string, roundToZero = false): number | string {
    if (value === undefined || value === null || value === '') {
      return typeof value === 'number' ? 0 : NO_VALUE;
    }

    const numericValue = typeof value === 'number' ? value : parseFloat(value);

    if (isNaN(numericValue)) {
      return NO_VALUE;
    }

    if (numericValue < 0 && roundToZero) {
      return 0;
    }

    return numericValue < 0 ? Math.ceil(numericValue) : Math.floor(numericValue);
  }
}
